// import { getNotificationListAPI } from "../apis/getNotificationListAPI";
import { getNotificationListAPI } from "../apis/announcementApi";
import localforage from "localforage";

export let getNotificationState = { get: false };

export const getNotificationReducer = (state, action) => {
  switch (action.type) {
    case "get":
      getNotificationState.get = true;
      getNotificationList();
      return { ...state };
    case "cancel":
      getNotificationState.get = false;
      return { ...state };
    default:
      break;
  }
};

export const getNotificationList = async () => {
  const companyId = await localforage.getItem("userCompanyID");
  const userData = await localforage.getItem("user");
  const notificationListObjArr = await getNotificationListAPI(
    15,
    [companyId, userData.id],
    1
  );
  if (notificationListObjArr) {
    const checkHasNewNotification =
      notificationListObjArr.notifications?.filter(
        notification => notification.read_at === null
      );
    return {
      notificationListObjArr: notificationListObjArr.notifications,
      checkHasNewNotification: checkHasNewNotification
    };
  }
};
